import { IEmployeeCheck, ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export interface IGenerateCheckPreviewRequestBody {
  checkIDs: string[];
  companyID: string;
  testMode: boolean;
}

export const generateCheckPreview = (axios: IAxiosInstance) => {
  return async (body: IGenerateCheckPreviewRequestBody) => {
    const response = await axios.with502Retry.post<
      ZealApiResponse<IEmployeeCheck["preview"][]>
    >(`/api/picard/generate-check-preview`, body, {});

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
